var cell_default = {
  "cell": "pL1Eg",
  "header": "LfKWR",
  "selected": "Rf6aS",
  "editing": "neMfP",
  "singleSelection": "v0Wx3",
  "hideLastBlock": "_2W-Db",
  "editorWrapper": "slbBt",
  "viewerWrapper": "HkBk-",
  "hideFirstBlock": "GJFLk",
  "editor": "RrYGq",
  "edit": "-LsTG",
  "view": "w89sR",
  "editingToolbarWrapper": "KyE3K",
  "selectAll": "_48zCZ",
  "disableSelection": "LBDxr"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
